import axios from 'axios';

export const getUserBooks = async () => {
    try {
        const response = await axios.get('/api/my-books', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`,
            },
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching user books:', error);
        throw error;
    }
};
